import { useQuery } from 'react-query';
import { Product } from '../../../interfaces/product.interface';
import { apiRQ } from '../../api';

const getProduct = async (id: string | undefined): Promise<Product> => {
  const resp = await apiRQ.get<Product>(`/products/${id}`, { params: { editForm: true } });

  return resp.data;
};

export const useProduct = (id: string | undefined) => {
  return useQuery<Product, Error>(['getProduct', id], () => getProduct(id), {
    enabled: id !== 'create',
    cacheTime: 200,
    refetchOnWindowFocus: false,
  });
};
